import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { Select } from 'antd';

import './AirSelectWithLabel.css';

@inject('translationsStore', 'connectionRequestsStore')
@observer
export default class AirSelectWithLabel extends Component {
  render() {
    const cls = classNames({
      [this.props.className]: !!this.props.className,
      AirSelectWithLabel: true
    });
    const clsDropdown = classNames({
      [this.props.dropdownClassName]: !!this.props.dropdownClassName,
      AirSelectWithLabelDropdown: true
    });
    return (
      <div className={cls}>
        <div className="label">{this.props.label}</div>
        <div className="control">
          <Select {...this.props} dropdownClassName={clsDropdown}>
            {this.props.children}
          </Select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirSelectWithLabel/AirSelectWithLabel.js